<template>
	<transition name="fade" mode="out-in">
		<text-button
			v-if="mailCustomerWhenAvailable"
			class="_secondary"
			text="Meddela mig"
			:size="buttonSize"
			:width="width"
			:center="center"
			@click="showMailInput()"
		/>
		<text-button
			v-else-if="product.minimumRankLevel && product.minimumRankLevel > this.userRankLevel"
			:variant="secondaryBuyButton ? 'secondary' : null"
			:text="text"
			:size="buttonSize"
			:width="width"
			:center="center"
			:disabled="! canBuy"
			@click="openLogin"
		/>
		<text-button
			v-else-if="! buyButtonClicked && product.price"
			:variant="secondaryBuyButton ? 'secondary' : null"
			:text="text"
			:size="buttonSize"
			:width="width"
			:center="center"
			:disabled="! canBuy"
			@click="updateButton"
		/>
		<text-button
			v-else-if="product.price"
			variant="cart"
			leftIcon="check_mark"
			rightIcon="chevron_right"
			:text="text || '&nbsp;'"
			:size="buttonSize"
			:width="width"
			:center="center"
			@click="updateButton"
		/>
	</transition>
</template>

<script>
import alert from 'alert';
import store from 'datastore';
import { t } from 'datastore/i18n';
import { sendGoogleOptimizeEvent, convertToCdnUrl, scrollToY, isProductInSecretMode, canUserViewProductInSecretMode } from 'utils';
import bus from 'eventbus';
import {mapGetters, mapState} from 'vuex';
import { isDesktop } from 'mediaQuery';

export default {
	store,
	props: {
		product: {
			type: Object,
			required: true,
		},
		size: { default: 'big' },
		buttonSize : {
			type: String,
			default: 'normal',
		},
		insured: {
			type: Boolean,
			default: false,
		},
		secondaryBuyButton: {
			type: Boolean,
			default: false,
		},
		shouldShowAccessoriesPopup: {
			type: Boolean,
			default: false,
		},
		/* Button sizes:
			large
			normal
			small
			tiny
		*/
		buttonSize : {
			type: String,
			default: 'normal',
		},
		stretch: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: 'normal',
			required: false,
		},
		center: {
			type: Boolean,
			default: false,
		},
		parentElement: {
			type: String,
			default: '',
		},
		subscription: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			buyButtonClicked: false,
		};
	},
	mounted () {
		bus.$on('product-page.add-to-cart', this.showGoToCartButton);
		bus.$on('product-page.remove-from-cart', this.changeCartButton);
		bus.$on('btn.update', this.changeCartButton);
	},
	beforeDestroy () {
		bus.$off('product-page.add-to-cart', this.showGoToCartButton);
		bus.$off('product-page.remove-from-cart', this.changeCartButton);
		bus.$off('btn.update', this.changeCartButton);
	},
	methods: {
		convertToCdnUrl,
		t: t.prefix('BUY_BTN'),
		addToCart () {
			if (this.fullyBooked) {
				alert('Denna produkt är tillfälligt fullbokad och kan därför inte läggas till i varukorgen');// @TODO översätt
				return;
			}
			if (this.product.discontinued && ! this.inStock) {
				alert('Denna produkt har tyvärr utgått och kan därför inte läggas till i varukorgen');// @TODO översätt
				return;
			}
			if (this.notYetAvailable) {
				alert('Denna produkt kan inte köpas ännu!');// @TODO översätt
				return;
			}
			sendGoogleOptimizeEvent('optimize.add_to_cart'); // Statistik för AB-tester

			let extraData = {};
			if (this.insured) {
				if (typeof this.product.extraData === 'undefined') {
					extraData = {};
				}
				extraData.insured = true;
			}

			extraData.source = this.$route.name;
			const cartProducts = store.state.cart.rows.map(item => item.product.id);
			const hasValue = cartProducts.some(el => el === this.product.id);
			const hasGiftCard = (cartProducts.some(el => el === 290553) && this.product.id !== 290553);

			if (! hasValue && ! hasGiftCard) {
				const trackingData = {
					event: 'addToCart',
					source: this.parentElement !== '' ? this.parentElement : this.$route.name,
					rating: true,
					stock: true,
					coupon: true,
				}
				this.$store.dispatch('cart/add', {
					product: this.product,
					extraData: extraData,
					trackingData: trackingData,
				});
			} else if (hasGiftCard) {
				alert('Ajdå! Din varukorg innehåller både fysiska och digitala produkter. Slutför din första beställning eller töm din varukorg.');
			} else {
				alert('Du har redan denna vara i varukorgen.');
			}

			if (this.product?.ticket) {
				const data = {
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE'
				};
				waja.get('productdiscovery/click/' + this.product.ticket + '/addToCart').data(data).go();
			}

			let parent = this.$parent;
			while (parent) {
				if (parent.buyButtonClick) {
					parent.buyButtonClick(this.product);
					break;
				}
				parent = parent.$parent;
			}
		},
		openLogin (event) {
			event.preventDefault();

			if (! this.isLoggedIn) {
				bus.$emit('open:login');
			}
			if (! this.minimumRankRuleFulfilled && ! this.isLoggedIn) {
				alert('Du behöver vara inloggad för att kunna köpa denna produkt');
				return;
			}
			if (! this.minimumRankRuleFulfilled && this.isLoggedIn) {
				alert('Du har för låg medlemsnivå för kunna köpa denna produkt');
				return;
			}
		},
		updateButton (event) {
			event.preventDefault();
			if (! this.buyButtonClicked) {
				if (this.subscription) {
					this.$emit('addPhoneSubscription');
				} else {
					this.$emit('triggerInsurance');
					this.$emit('getOffers');
					this.addToCart();
				}
			} else {
				bus.$emit('cart:open');
				bus.$emit('product-page.remove-from-cart');
				bus.$emit('modal.close');
			}
			if (this.canBuy && ! this.subscription) {
				this.buyButtonClicked = true;
			}
		},
		// If one 'Add to cart' is clicked on product page, this will update the rest
		showGoToCartButton (value) {
			this.buyButtonClicked = true;
			/* Check is bundle or main product is added to cart, if only main prod:
			**  emit to the bundle so it wont add the main product twice if bundle is added afterwards */
			if (value === 'main-prod') {
				bus.$emit('product-page.main-product-added');
			}
		},
		changeCartButton () {
			this.buyButtonClicked = false;
		},
		scrollToTop () {
			scrollToY(0, 0.5);
		},
		showMailInput() {
			bus.$emit('show-mail-input-modal');
		},
	},
	computed: {
		canBuy () {
			return ! this.onlyStorePickup && ! this.fullyBooked && ! (this.product.discontinued && ! this.inStock) && ! this.notYetAvailable && this.minimumRankRuleFulfilled;
		},
		onlyStorePickup () {
			if (Object.keys(this.product.stock).length) {
				let webStock = this.product.stock.web;
				/* Checks is product is in stock in actual warehouse and not just webstock */
				if (! this.eolFromStoreShipmentEnabled) {
					webStock = Object.keys(this.product.stock.webStock).some(storeId => ! this.product.stock.hasOwnProperty(storeId) && this.product.stock.webStock[storeId]);
				}
				return this.product.discontinued && this.isReleased && ! webStock;
			}
			return false;
		},
		isReleased () {
			if (! (this.product && this.product.release)) {
				return true;
			}
			const date = new Date();
			date.setTime(this.product.release.timestamp * 1000);
			const now = new Date();
			return now >= date;
		},
		inStock () {
			if (this.product.stock) {
				const stock = this.product.stock;
				for (const key in stock) {
					if (isNaN(key) && key !== 'web') {
						continue;
					}
					if (stock[key] > 0) {
						return true;
					}
				}
			}
			return false;
		},
		notYetAvailable () {
			return this.product.statusCodes && this.product.statusCodes.indexOf(10/* Kommer snart */) >= 0;
		},
		fullyBooked () {
			return this.product.statusCodes && this.product.statusCodes.indexOf(9/* Tillfälligt fullbokad*/) >= 0;
		},
		mailCustomerWhenAvailable() {
			if (isProductInSecretMode(this.product)) {
				if (canUserViewProductInSecretMode(this.user, this.product)) {
					return false;
				}
				return true;
			} else {
				return this.product.statusCodes && this.product.statusCodes.indexOf(11/* Mail when available*/) >= 0;
			}
		},
		type () {
			if (this.notYetAvailable) {
				return 'not-yet-available';
			}
			if (this.fullyBooked) {
				return 'fully-booked';
			}
			if (this.product.discontinued && ! this.inStock) {
				return 'unavailable';
			}
			return this.isReleased ? 'buy' : 'preorder';
		},
		text () {
			if (this.onlyStorePickup) {
				return 'Kan endast köpas i butik';
			}
			if (this.subscription) {
				return 'Köp med abonnemang';
			}
			if (! this.isLoggedIn && this.product.minimumRankLevel > 0) {
				return 'Enbart tillgänglig för medlemmar';
			}
			if (this.isLoggedIn && this.product.minimumRankLevel > this.userRankLevel) {
				return 'Ej tillgänglig för din medlemsnivå';
			}
			if (this.buyButtonClicked) {
				return 'Gå till varukorgen';
			}
			if (this.type === 'buy' && this.size === 'small') {
				return '';
			}
			return this.t(this.type.toUpperCase() + '.' + this.size.toUpperCase());
		},
		title () {
			return this.t(this.type.toUpperCase() + '.BIG');
		},
		minimumRankRuleFulfilled () {
			if ((! this.isLoggedIn && this.product.minimumRankLevel > 0) || (this.isLoggedIn && this.product.minimumRankLevel > this.userRankLevel)) {
				return false;
			} else {
				return true;
			}
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			userRankLevel: 'user/rankLevel',
		}),
		...mapState({
			user: state => state.user,
			eolFromStoreShipmentEnabled: state => state.shippingMethodRelatedInfo.eolFromStoreShipmentEnabled,
		}),
	},
	watch: {
		// When sticky button isn't remounted, this ensures the button class is updated
		product (to, frm) {
			if(to.id !== frm.id) {
				this.buyButtonClicked = false;
			}
		},
	},
};
</script>
